import { j as e, T as _, B as re } from "./Spinner-yxPaS-Vf.js";
import b, { useRef as D } from "react";
import { C as M } from "./Container-24HM5JiH.js";
import { S as y } from "./Section-4apwAAJH.js";
import { R as f, C as h } from "./Row-sdSXGr8k.js";
import { O as k, T as p } from "./Transition-Mra728p1.js";
import { P as se, G as R } from "./ProfileTile-lCRqtNiX.js";
import { styled as m, css as x } from "styled-components";
import { e as c, f as B, d as G, m as ie, F as ne } from "./index-tc-On6zr.js";
import { r as u, s as te, p as ae, T as C, a as T, B as I, j as le, c as oe } from "./style-ImpGK6sv.js";
import { a as ce } from "./getBreakpoint-dhJSqYZr.js";
import { u as de } from "./useResizeObserver-ghdBe7Hs.js";
import { S as me } from "./ShowMore-jTGWFK_P.js";
import { A as xe, C as d, T as A, W as X, I as q } from "./TileSkeleton-QAoxs-Ce.js";
import { A as P } from "./aspect-ratios-JlfRqse9.js";
import { T as S } from "./typography.styled-F4iuH4S1.js";
import { A as he } from "./icon-arrow-8NL91Y9P.js";
import { i as pe } from "./isClient-bZWD-rdJ.js";
import { C as je } from "./Carousel-mirBhBrc.js";
import { c as U } from "./Container.utils-zmerNVMS.js";
import { a as $e, i as fe, d as ge, c as ue, u as J, b as be } from "./useInputType-sJmrxM6l.js";
import { p as ye } from "./domPurify-ugx5Lmst.js";
const L = m(f)`
  row-gap: ${c.spacer5};
  margin-bottom: ${({ $hasMargin: r }) => r && `${u(72)}`};
`, ve = m.div.attrs({ $display: "flex", $alignItems: "center" })`
  ${B};

  width: 100%;
`, we = m.div`
  ${({ size: r }) => te(r)}

  aspect-ratio: ${P["1:1"]};
  position: relative;
  overflow: hidden;
  border-radius: ${G.round};
  ${ae(x`
    forced-color-adjust: preserve-parent-color;
  `)}

  ${xe}
`, K = ({ imageSize: r = 64, contentHeight: s = 20, contentWidth: i = 40 }) => /* @__PURE__ */ e.jsxs(ve, { id: "profileTileSkeleton", children: [
  /* @__PURE__ */ e.jsx(we, { size: r }),
  /* @__PURE__ */ e.jsx(d, { height: s, width: i, $ml: "spacer4" })
] }), Te = ({ itemsLength: r = 6 }) => {
  const s = b.useRef(
    Array(r).fill(0).map((i, t) => t)
  );
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: s.current.map((i) => /* @__PURE__ */ e.jsx(h, { $col: { xs: 12, md: 6, lg: 4, xxl: 3 }, children: /* @__PURE__ */ e.jsx(K, {}) }, i)) });
}, w = {
  xs: 6,
  md: 4,
  lg: 6,
  xxl: 8
}, ke = ({
  title: r,
  items: s,
  theme: i,
  t,
  onChange: a,
  onShowMore: l,
  componentStatus: n = "initial",
  isCollapsable: o = !1
}) => {
  const { showMoreLabel: g } = t, [, j] = de();
  if (n === "error")
    return null;
  const $ = ce(w), E = s == null ? void 0 : s.slice(0, w[$]), v = s == null ? void 0 : s.slice(w[$]), O = (Y) => Y.map((z) => {
    const { primaryTitle: F, ...Z } = z;
    return /* @__PURE__ */ e.jsx(h, { $col: { xs: 12, md: 6, lg: 4, xxl: 3 }, children: /* @__PURE__ */ e.jsx(
      se,
      {
        primaryTitle: F,
        onChange: (ee) => {
          a && a(ee, s == null ? void 0 : s.indexOf(z));
        },
        ...Z
      }
    ) }, F);
  });
  return /* @__PURE__ */ e.jsx(_, { theme: i, children: /* @__PURE__ */ e.jsx(y, { ref: j, "data-qa": "related-departments", children: /* @__PURE__ */ e.jsxs(M, { $fluid: !0, children: [
    r && /* @__PURE__ */ e.jsx(S, { $textEllipsis: 2, $mb: "spacer5", $variant: C.headingLSerif, as: "h2", children: r }),
    /* @__PURE__ */ e.jsxs(k, { children: [
      /* @__PURE__ */ e.jsx(p, { visible: n === "initial", children: /* @__PURE__ */ e.jsx(L, { $hasMargin: !0, children: /* @__PURE__ */ e.jsx(Te, { itemsLength: w[$] }) }) }),
      /* @__PURE__ */ e.jsx(p, { visible: n === "ready", children: s && s.length > 0 && /* @__PURE__ */ e.jsxs(L, { children: [
        O(E),
        (v == null ? void 0 : v.length) > 0 && /* @__PURE__ */ e.jsx(me, { t: { showMoreLabel: g }, isCollapsable: o, onChange: l, children: /* @__PURE__ */ e.jsx(L, { children: O(v) }) })
      ] }) })
    ] })
  ] }) }) });
}, Ce = m.div.attrs({
  $justifyContent: "space-between",
  $alignItems: "center",
  $flexWrap: "wrap"
})`
  ${B}
  ${ie}
`, Se = ({ $col: r }) => {
  const s = b.useRef(
    Array(3).fill(0).map((i, t) => t)
  );
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: s.current.map((i) => /* @__PURE__ */ e.jsx(h, { $col: r, $mb: "spacer5", children: /* @__PURE__ */ e.jsx(A, { location: !0 }) }, i)) });
}, Ee = ({
  t: { title: r, viewAll: s },
  theme: i,
  componentStatus: t = "initial",
  appearance: a = "standard",
  href: l,
  ...n
}) => t === "error" ? null : /* @__PURE__ */ e.jsx(_, { theme: i, children: /* @__PURE__ */ e.jsx(y, { "data-qa": "related-auctions", children: /* @__PURE__ */ e.jsxs(M, { $fluid: !0, children: [
  /* @__PURE__ */ e.jsxs(Ce, { $mb: "spacer5", children: [
    /* @__PURE__ */ e.jsx(S, { as: "h2", $variant: C.headingLSerif, children: r }),
    l && /* @__PURE__ */ e.jsx(
      re,
      {
        href: l,
        icon: {
          icon: he,
          position: "right",
          rotation: 180
        },
        variant: "icon",
        children: s
      }
    )
  ] }),
  a === "standard" && /* @__PURE__ */ e.jsx(Le, { ...n, componentStatus: t }),
  a === "collage" && /* @__PURE__ */ e.jsx(Re, { ...n, componentStatus: t })
] }) }) }), W = {
  sm: { sm: 12, md: 6, lg: 3 },
  md: { sm: 12, md: 6, lg: 4 },
  lg: { sm: 12, md: 6 }
}, Le = ({
  componentStatus: r,
  gridSize: s = "md",
  auctions: i,
  onChange: t
}) => /* @__PURE__ */ e.jsxs(k, { children: [
  /* @__PURE__ */ e.jsx(p, { visible: r === "initial", children: /* @__PURE__ */ e.jsx(f, { children: /* @__PURE__ */ e.jsx(Se, { $col: W[s] }) }) }),
  /* @__PURE__ */ e.jsx(p, { visible: r === "ready", children: i && i.length > 0 && /* @__PURE__ */ e.jsx(f, { children: i.map(({ primaryTitle: a, ...l }, n) => /* @__PURE__ */ e.jsx(h, { $col: W[s], $mb: "spacer5", children: /* @__PURE__ */ e.jsx(
    R,
    {
      primaryTitle: a,
      ...l,
      headingLevel: "h3",
      onClick: (o) => {
        t && t(o, n);
      }
    }
  ) }, a)) }) })
] }), Re = ({ componentStatus: r, auctions: s, onChange: i }) => {
  const t = b.useRef(
    Array(3).fill(0).map((n, o) => o)
  ), a = s == null ? void 0 : s[0], l = s == null ? void 0 : s.slice(1);
  return /* @__PURE__ */ e.jsxs(k, { children: [
    /* @__PURE__ */ e.jsx(p, { visible: r === "initial", children: /* @__PURE__ */ e.jsxs(f, { children: [
      /* @__PURE__ */ e.jsx(h, { $col: { md: 5, sm: 12 }, $mb: "spacer5", children: /* @__PURE__ */ e.jsx(A, {}) }),
      /* @__PURE__ */ e.jsx(h, { $col: { md: 7, sm: 12 }, children: t.current.map((n) => /* @__PURE__ */ e.jsx(A, { layout: "list", $mb: { xs: "spacer5", md: "spacer3" } }, n)) })
    ] }) }),
    /* @__PURE__ */ e.jsx(p, { visible: r === "ready", children: s && s.length > 0 && /* @__PURE__ */ e.jsxs(f, { children: [
      /* @__PURE__ */ e.jsx(h, { $col: { md: 5, sm: 12 }, $mb: "spacer5", children: /* @__PURE__ */ e.jsx(
        R,
        {
          ...a,
          primaryTitle: a == null ? void 0 : a.primaryTitle,
          headingLevel: "h3",
          onClick: (n) => {
            i && i(n, 0);
          }
        }
      ) }),
      /* @__PURE__ */ e.jsx(h, { $col: { md: 7, sm: 12 }, children: (l || []).map(({ primaryTitle: n, ...o }, g) => /* @__PURE__ */ e.jsx(
        R,
        {
          primaryTitle: n,
          ...o,
          headingLevel: "h3",
          onClick: (j) => {
            i && i(j, g);
          },
          layout: "list",
          $mb: { xs: "spacer5", md: "spacer3" }
        },
        n
      )) })
    ] }) })
  ] });
};
m(y)`
  overflow: hidden;
`;
const Ie = m(S).attrs({ $fluid: !0 })`
  ${U}
`, Ae = m(ne).attrs((r) => ({ $fluid: !0, ...r }))`
  display: flex;
  padding-block: ${c.spacer2};
  margin-block: -${c.spacer2};
  margin-bottom: calc(${c.spacer10} + ${c.spacer2});
  overflow: hidden;

  ${T(
  I.sm,
  x`
      ${U}
    `
)}
  ${({ $gap: r }) => {
  if (r)
    return typeof r == "string" ? x`
        column-gap: ${c[r]};
      ` : Object.entries(r).map(([s, i]) => s === I.xs ? x`
          column-gap: calc(${c[i]} / 2);
          padding-left: calc(${c[i]} / 2);
        ` : T(
      s,
      x`
          column-gap: ${c[i]};
        `
    ));
}}
  > * {
    flex-shrink: 0;

    ${({ $tileWidth: r }) => {
  if (r)
    return typeof r == "number" ? x`
          width: ${r}px;
        ` : Object.entries(r).map(
      ([s, i]) => T(
        s,
        x`
            width: ${i}px;
          `
      )
    );
}}
  }
`, _e = (r) => /* @__PURE__ */ e.jsxs(X, { ...r, $flexDirection: "column", children: [
  /* @__PURE__ */ e.jsx(q, { $aspectRatio: P["7:8"] }),
  /* @__PURE__ */ e.jsx(d, { height: 20, style: { marginTop: "18px" } }),
  /* @__PURE__ */ e.jsx(d, { height: 20, $mt: "spacer1", width: 75 }),
  /* @__PURE__ */ e.jsx(d, { height: 42, $mt: "spacer4" })
] }), Me = (r) => /* @__PURE__ */ e.jsxs(X, { ...r, $flexDirection: "column", children: [
  /* @__PURE__ */ e.jsx(q, { $aspectRatio: P["8:5"] }),
  /* @__PURE__ */ e.jsx(d, { height: 18, $mt: "spacer5" }),
  /* @__PURE__ */ e.jsx(d, { height: 40, $mt: "spacer2", width: 75 }),
  /* @__PURE__ */ e.jsx(d, { height: 60, $mt: "spacer2", width: 50 }),
  /* @__PURE__ */ e.jsx(d, { height: 18, $mt: "spacer4", width: 30 })
] }), Be = ({
  children: r,
  title: s,
  theme: i,
  tileWidth: t,
  t: a,
  gap: l,
  componentStatus: n,
  loadingComponent: o
}) => {
  if (n === "error" || n === "ready" && b.Children.count(r) === 0)
    return null;
  const g = {
    gap: l,
    dragEnabled: !0,
    isIntrinsicHeight: !0,
    variant: "progress",
    tileWidth: t,
    t: a,
    overflow: "visible"
  }, j = new Array(8).fill(0).map(($, E) => E);
  return /* @__PURE__ */ e.jsx(_, { theme: i, children: /* @__PURE__ */ e.jsxs(y, { children: [
    s && /* @__PURE__ */ e.jsx(
      Ie,
      {
        as: "h2",
        $mb: "spacer4",
        $variant: C.headingLSerif,
        $px: { xs: "spacer4", sm: "spacer0" },
        children: s
      }
    ),
    /* @__PURE__ */ e.jsxs(k, { children: [
      /* @__PURE__ */ e.jsx(p, { visible: n === "initial", children: /* @__PURE__ */ e.jsx(Ae, { $gap: l, $tileWidth: t, children: j == null ? void 0 : j.map(($) => /* @__PURE__ */ e.jsx(b.Fragment, { children: o }, $.toString())) }) }),
      pe && /* @__PURE__ */ e.jsx(p, { visible: n === "ready", children: /* @__PURE__ */ e.jsx(je, { ...g, children: r }) })
    ] })
  ] }) });
}, N = m.div`
  ${le("opacity")};
  opacity: ${({ $isLoading: r }) => r ? 0 : 1};
  display: grid;
  place-items: center;

  iframe {
    max-width: 100%;

    ${({ $isInstagramEmbed: r }) => r && x`
        /* Temporarily overriding the inline style to set a max-width specifically for Instagram embeds.
           In the future, with the implementation of the oEmbed API solution, this width will be configured directly as a parameter. */
        max-width: ${u(550)} !important;
      `}
`, Pe = ({ t: r, postId: s, scriptSource: i, onLoad: t, onClick: a, inputType: l }) => {
  const n = D(null), o = ue({ postId: s, scriptSource: i, onLoad: t }, n);
  return J(a, s, l), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    o && /* @__PURE__ */ e.jsx(V, { placeholder: r == null ? void 0 : r.placeholder }),
    /* @__PURE__ */ e.jsx(N, { $isLoading: o, ref: n })
  ] });
}, Oe = ({ scriptSource: r, html: s, onLoad: i, onClick: t, inputType: a, postId: l }) => {
  const n = D(null), o = be({ html: s, scriptSource: r, onLoad: i }, n);
  return J(t, l, a), /* @__PURE__ */ e.jsx(
    N,
    {
      $isLoading: o,
      ref: n,
      dangerouslySetInnerHTML: { __html: ye(s) },
      $isInstagramEmbed: !0,
      id: l
    }
  );
}, ze = (r) => {
  const s = $e(), i = () => fe(r) ? /* @__PURE__ */ e.jsx(Pe, { ...r, inputType: s }) : ge(r) ? /* @__PURE__ */ e.jsx(Oe, { ...r, inputType: s }) : null;
  return /* @__PURE__ */ e.jsx(y, { $spacing: "sm", "data-qa": "social-media-embeds-component", children: /* @__PURE__ */ e.jsx(M, { $fluid: !0, children: /* @__PURE__ */ e.jsx(f, { children: /* @__PURE__ */ e.jsx(h, { $col: { xs: 12 }, children: i() }) }) }) });
}, Q = m.div.attrs({
  $display: "flex",
  $alignItems: "start",
  $justifyContent: "space-between",
  $flexDirection: "column"
})`
  ${B};

  max-width: ${u(550)};
  height: ${u(540)};
  border: 1px solid ${oe.silverLight};
  border-radius: ${G.sm};
  padding: ${c.spacer4};
  margin: 0 ${c.spacer2};

  ${T(
  I.sm,
  x`
      height: ${u(600)};
      margin: 0 auto;
    `
)}
`, H = m.div`
  width: 100%;
`, V = ({ placeholder: r }) => /* @__PURE__ */ e.jsxs(Q, { id: "socialEmbedsSkeleton", children: [
  /* @__PURE__ */ e.jsx(K, { contentWidth: 25, contentHeight: 15, imageSize: 48 }),
  r && /* @__PURE__ */ e.jsx(H, { children: /* @__PURE__ */ e.jsx(S, { $textAlign: "center", $variant: C.bodyMedium, children: r }) }),
  /* @__PURE__ */ e.jsxs(H, { children: [
    /* @__PURE__ */ e.jsx(d, { height: 15, $mb: "spacer2", width: 60 }),
    /* @__PURE__ */ e.jsx(d, { height: 15, width: 30 })
  ] })
] }), lr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EmbedsWrapper: Q,
  GenericTileSkeleton: Me,
  LotTileSkeleton: _e,
  RelatedAuctions: Ee,
  RelatedDepartments: ke,
  RelatedTileCarousel: Be,
  SocialMediaEmbeds: ze,
  SocialMediaSkeleton: V
}, Symbol.toStringTag, { value: "Module" }));
export {
  Q as E,
  Me as G,
  _e as L,
  ke as R,
  ze as S,
  Ee as a,
  Be as b,
  V as c,
  lr as i
};
